// extracted by mini-css-extract-plugin
export var label = "_cq-2";
export var slideContainer = "_cq-0";
export var slider = "_cq-1";